import { z } from "zod";
import type { Prisma } from "@prisma/client";
import { utmAttributionSchema } from "@/lib/analytics/utm";
import {
  LEAD_FORM_SOURCES,
  leadFormFieldMapItemSchema,
  normalizeLeadFormFieldMap,
  type LeadFormFieldMapItem,
  type LeadFormSource,
} from "@/lib/bitrix24/lead-form-fields";

export {
  LEAD_FORM_SOURCES,
  leadFormFieldMapItemSchema,
  type LeadFormFieldMapItem,
  type LeadFormSource,
};

/** Дефолтный маппинг полей (объявлен здесь, без re-export — стабильно для Turbopack). */
export const DEFAULT_FIELD_MAP: LeadFormFieldMapItem[] = [
  { source: "name", target: "TITLE", enabled: true, required: true },
  { source: "email", target: "EMAIL", enabled: true, required: true },
  { source: "phone", target: "PHONE", enabled: true, required: false },
  { source: "company", target: "COMMENTS", enabled: true, required: false },
  { source: "message", target: "COMMENTS", enabled: true, required: false },
];

export const leadFormPayloadSchema = z.object({
  name: z.string().trim().min(1).max(120),
  email: z.string().trim().email().max(200),
  phone: z
    .string()
    .trim()
    .max(40)
    .optional()
    .refine((v) => !v || /^\+7\d{10}$/.test(v), {
      message: "Некорректный телефон",
    }),
  company: z.string().trim().max(200).optional(),
  message: z.string().trim().max(2000).optional(),
  trace: z.string().trim().min(1).max(100_000).optional(),
  utm: utmAttributionSchema.optional(),
});

export type LeadFormPayload = z.infer<typeof leadFormPayloadSchema>;

export function parseFieldMap(value: unknown): LeadFormFieldMapItem[] {
  return normalizeLeadFormFieldMap(value);
}

export function renderTitleTemplate(
  template: string,
  payload: LeadFormPayload,
): string {
  return template
    .replaceAll("{{name}}", payload.name)
    .replaceAll("{{email}}", payload.email)
    .replaceAll("{{phone}}", payload.phone ?? "")
    .replaceAll("{{company}}", payload.company ?? "")
    .replaceAll("{{message}}", (payload.message ?? "").slice(0, 80))
    .trim()
    .slice(0, 200);
}

export function fieldMapToJson(
  map: LeadFormFieldMapItem[],
): Prisma.InputJsonValue {
  return map as unknown as Prisma.InputJsonValue;
}

export function formCaseKeyForPlanSlug(slug: string): string | null {
  const s = slug.trim().toLowerCase();
  if (s === "enterprise" || s.includes("enterprise")) {
    return "enterprise-request";
  }
  if (
    s === "white-label" ||
    s === "white_label" ||
    s.includes("white-label") ||
    s.includes("white_label")
  ) {
    return "white-label-request";
  }
  return null;
}
